import React from 'react';

import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

import classes from './PasswordRequirements.module.css';

const passwordRequirements = props => {
    return (
        <Popper
            open={props.open}
            anchorEl={props.anchorEl}
            placement={props.placement}
            transition
        >
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <Paper className={classes.PasswordRequirements}>
                        <span>Password Requirements:</span>
                        <ul>
                            <li>At Least 8 Characters Long</li>
                            <li>At Least 1 Number</li>
                            <li>At Least 1 Special Character</li>
                            <li>At Least 1 Uppercase Character</li>
                            <li>At Least 1 Lowercase Character</li>
                            <li>No Spaces</li>
                        </ul>
                    </Paper>
                </Fade>
            )}
        </Popper>
    );
};

export default passwordRequirements;
